import React from 'react';
import { useGetFeatureAnalysesListQuery } from 'src/redux/services/imports';
import EmptyState from 'src/frontend-common/components/EmptyState';
import InsightsTable from 'src/pages/InsightsPage/InsightsTable';
import Column from 'src/frontend-common/components/Column';
import { Box, useTheme } from '@mui/material';
import LoadingScreen from 'src/frontend-common/components/LoadingScreen';
import FailureScreen from 'src/frontend-common/components/FailureScreen';
interface InsightsTableWrapperProps {
  showSpinner: boolean;
}

const InsightsTableWrapper: React.FC<InsightsTableWrapperProps> = ({ showSpinner }) => {
  const {
    data: featureAnalysesImportData,
    isLoading: isLoadingFeatureAnalysesImportData,
    isError: isErrorFeatureAnalysesImportData,
  } = useGetFeatureAnalysesListQuery('', { pollingInterval: 3000 });

  const theme = useTheme();

  return (
    <>
      {isLoadingFeatureAnalysesImportData && <LoadingScreen logo sx={{ height: 'calc(100vh - 317px)' }} />}
      {!featureAnalysesImportData && isErrorFeatureAnalysesImportData && (
        <FailureScreen>An error occurred while fetching feature analyses import data, please retry.</FailureScreen>
      )}
      {featureAnalysesImportData?.documents.length === 0 && (
        <Column>
          <Box component="div" style={{ position: 'relative', backgroundColor: 'white' }}>
            <EmptyState style={{ width: '100%', padding: theme.spacing(10, 2.5) }} />
          </Box>
        </Column>
      )}
      {featureAnalysesImportData && featureAnalysesImportData.documents.length > 0 && (
        <Box>{showSpinner ? <LoadingScreen logo sx={{ height: 'calc(100vh - 317px)' }} /> : <InsightsTable dataTable={featureAnalysesImportData} />}</Box>
      )}
    </>
  );
};

export default InsightsTableWrapper;
